import axios from 'axios';

import { createAxiosResponseInterceptorWithRefresh } from './refreshInterceptor';

export const API_URL = process.env.REACT_APP_SERVER_URL || 'https://localhost:4000/api';

const axiosApi = axios.create({
  baseURL: API_URL,
  withCredentials: true,
});

createAxiosResponseInterceptorWithRefresh(axiosApi);

export async function get(url, config = {}) {
  return await axiosApi.get(url, { ...config }).then((response) => response.data);
}

export async function getImage(url, config = {}) {
  return await axiosApi
    .get(url, {
      ...config,
      responseType: 'blob',
    })
    .then((response) => response.data);
}

export async function postFormData(url, data, config = {}) {
  return axiosApi.post(url, data, { ...config }).then((response) => response);
}

export async function post(url, data, config = {}) {
  return axiosApi.post(url, { ...data }, { ...config }).then((response) => response);
}

export async function put(url, data, config = {}) {
  return axiosApi.put(url, { ...data }, { ...config }).then((response) => response);
}

export async function patch(url, data, config = {}) {
  return axiosApi.patch(url, { ...data }, { ...config }).then((response) => response);
}

export async function del(url, config = {}) {
  return await axiosApi.delete(url, { ...config }).then((response) => response);
}
